const trimPathname = (pathname) => {
  if (!pathname || typeof pathname !== 'string') {
    return '';
  }

  const withoutQuery = pathname.split('?')[0]?.split('#')[0] || '';
  const trimmed = withoutQuery.replace(/\/+$/, '');
  return trimmed || '/';
};

export const LEGAL_PAGES = [
  { key: 'privacy', path: '/privacy' },
  { key: 'terms', path: '/terms' },
  { key: 'cookies', path: '/cookies' },
  { key: 'notice', path: '/legal' }
];

const LEGAL_ALIASES = {
  privacy: ['/privacy-policy', '/legal/privacy'],
  terms: ['/terms-of-service', '/legal/terms'],
  cookies: ['/cookie-policy', '/legal/cookies'],
  notice: ['/legal/notice', '/legal-notice', '/imprint']
};

export const getLegalPath = (key) => {
  const match = LEGAL_PAGES.find((page) => page.key === key);
  return match?.path || null;
};

export const getLegalRouteKey = (pathname) => {
  const cleanedPath = trimPathname(pathname);
  if (!cleanedPath) return null;

  for (const page of LEGAL_PAGES) {
    if (page.path === cleanedPath) {
      return page.key;
    }
    const aliases = LEGAL_ALIASES[page.key] || [];
    if (aliases.includes(cleanedPath)) {
      return page.key;
    }
  }

  return null;
};

export const isLegalPath = (pathname) => Boolean(getLegalRouteKey(pathname));
